<template>
    <div id="page-winloss">
        <vx-card ref="filterCard" class="mb-1">
            <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <vs-input class="inputx" placeholder="Tài_khoản1,Tài_khoản2" v-model="accounts"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: fromDate, to: toDate}"
                        actionBtnText="Xem"
                    />
                </vs-col>
            </vs-row>
        </vx-card>
        <div class="vx-card pl-5 pr-5">
            <vs-table 
                :data="winloss"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
            >
                <template slot="header">
                    
                    <!-- ITEMS PER PAGE -->
                    <div class="">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                            <template v-if="h.render">
                                {{ h.render(data[indextr][h.field]) }}
                            </template>
                            <template v-else>
                                {{ data[indextr][h.field] }}
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import { AclRule } from 'vue-acl';
import numeral from 'numeral';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data(){
        return {
            itemsPerPage: 100,
            header: [ 
                { title:"Member", field:"member_name", render: function(val){ return val.toUpperCase(); } },
                { title:"Winloss", field:"winloss", render: function(val){ return numeral(val).format('0,0.00'); } }
            ],
            winloss: [],
            accounts: "",
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD")
        }
    },
    components: {
        vSelect,
        DateRangePicker
    },
    // beforeRouteUpdate (to, from, next) {
    //     this.date = to.query.date;
    //     this.fetchCheatIP(to.query.date);
       
    //     next();
    // },
    computed: {
        fetchAccountWinlossPermission(){
            return new AclRule('store_account_info').generate();
        },
    },
    methods:{
        fetchWinloss() {
            if(this.$acl.not.check('fetchAccountWinlossPermission')) return;

            let vm = this;
            let payload = {
                "accounts": this.accounts,
                "from": this.fromDate,
                "to": this.toDate
            };

            this.$http.post('accounts/info', payload).then((res) => {
                vm.winloss = res.data.data;
            });
        },
        onDateFilterChange(data){
            this.fromDate = data.fromDate;
            this.toDate = data.toDate;

            this.fetchWinloss();
        }
    },
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
</style>
